import { IQuery } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { Survey } from '../builders/survey_builder';

export class SurveyQuery implements IQuery {
  private _result: Survey[];

  constructor(private ngSurveyDatastore: IDatasource<Survey>) {
    ORM.registerQuery(this, this.ngSurveyDatastore);
  }

  run(): this {
    this._result = this.ngSurveyDatastore.values();
    return this;
  }

  get result() {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/queries/survey_query.ts